import get from 'lodash/get';

export default archetypeContent => get(archetypeContent, 'default_locale', 'en-US');
